import { useEffect } from 'react';
import throttle from 'lodash/throttle';
/**
 * Detects whether iOS Safari toolbar is visible
 * Adds "safari-toolbar-hidden" class when appropriate
 */
var useSafariToolbarDetection = function () {
    useEffect(function () {
        var ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var toolbarClass = 'safari-toolbar-hidden';
        var baseWindowHeight = Math.max(window.innerHeight);
        if (!ios) {
            // Exit early if not iOS browser
            return undefined;
        }
        var detectToolbar = throttle(function () {
            var newWindowHeight = Math.max(window.innerHeight);
            // If new height is more than 50px taller than original
            if (newWindowHeight - 50 > baseWindowHeight) {
                document.body.classList.add(toolbarClass);
            }
            else {
                document.body.classList.remove(toolbarClass);
            }
        }, 250);
        document.addEventListener('scroll', detectToolbar);
        return function () {
            document.body.classList.remove(toolbarClass);
            document.removeEventListener('scroll', detectToolbar);
        };
    }, []);
};
export default useSafariToolbarDetection;
//# sourceMappingURL=use-safari-toolbar-detection.js.map